import { render, staticRenderFns } from "./ReminderDelete.vue?vue&type=template&id=2e153fe9&"
import script from "./ReminderDelete.vue?vue&type=script&lang=js&"
export * from "./ReminderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports